module.exports = __webpack_public_path__ + "img/洱海2_1.c8851b12.jpg";